const apiKey = '4c92cd85c2c9efa4a6606acb2aa7d42c';

module.exports = {
  apiKey,
};
